module.exports = __webpack_public_path__ + "img/icon-p-130x130q80.7b6986ce.png";